"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pond = void 0;
const Storage_1 = require("./Storage");
const typeName = 'Pond';
class Pond extends Storage_1.Storage {
    constructor(ob) {
        var _a, _b;
        super({ ...ob, type: typeName });
        this.floorSize = (_a = ob.floorSize) !== null && _a !== void 0 ? _a : null;
        this.topArea = (_b = ob.topArea) !== null && _b !== void 0 ? _b : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            // name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of pond' },
            purpose: { type: 'String', editable: true, label: 'Purpose', name: 'purpose', description: 'Used for' },
            diameter: { type: 'Number', required: true, editable: true, label: 'Diameter', name: 'diameter', description: 'Diameter of pond - metre.cm' },
            depth: { type: 'Number', required: true, editable: true, label: 'Depth', name: 'depth', description: 'Depth of pond in m.cm' },
            floorSize: { type: 'Number', required: true, editable: true, label: 'Floor Size', name: 'floorSize', description: 'Area of the floor of the pond in m2' },
            topArea: { type: 'Number', required: true, editable: true, label: 'Top Area', name: 'topArea', description: 'Area of the top of the pond in m2' },
            constructionMaterial: {
                type: 'String',
                editable: true,
                label: 'Construction material',
                name: 'constructionMaterial',
                description: 'Material dam is contructed from if artifical',
            },
            comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
        };
    }
}
exports.Pond = Pond;
